/**
 *  @fileOverview: 首页-保费收入 柱状图
 *  @creator: CaoYanqi
 *  @Date: 2019/6/11
 *  @Last Modified by: 
 *  @Last Modified time:
 */
import * as React from 'react'
import {connect} from 'react-redux'
import {Empty, Popover} from "antd";
import ReactEcharts from 'echarts-for-react';
import {Link} from "react-router-dom";
import './feeCharts.less'

class FeeCharts extends React.Component{
  constructor(props){
    super(props);
    this.state={
      policyIncome:[
        {key:'',value:''}
      ]
    };
    this.content = (
      <div className="data_count_po_tips">
        <p className="title">统计规则：</p>
        <p className="desc">按承保时间统计近7天，截止昨日24点统计，包含当前账户及所有下级机构团队。</p>
        <p className="title marTop24">保费收入：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费。</p>
      </div>
    );
  }

  getBarOption(data){
    const _policyIncome = this.props.policyIncome;
    const xData = _policyIncome?_policyIncome.map(item=>item.preDate) : [];
    const yData = _policyIncome?_policyIncome.map(item=>item.premium) : []
    return {
      title: {
        // text: '',
        subtext: '横轴为日期，纵轴为保费收入',
        padding:[0,0,0,30],
        subtextStyle: {
          fontSize: 14,
          color:'#999'
        },
      },
      tooltip : {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid:{
        // top:0,
        right:'44px',
        bottom:'40px',
        left:'64px',
      },
      toolbox: {
        show : false,
        right:25,
        feature : {
          dataView : {show: true, readOnly: false},
          magicType : {show: true, type: ['line', 'bar']},
          restore : {show: true},
          saveAsImage : {show: true}
        },
        iconStyle:{
          normal:{
            borderColor:"#e03e38"
          },
          emphasis:{
            borderColor:"#c81f18"
          }
        }
      },
      calculable : true,
      xAxis : [
        {
          type : 'category',
          data : xData,
          axisLine:{ // x坐标轴线
            lineStyle:{
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel:{
            color:'#999',
            fontSize: 10,
            interval:0
          }
        }
      ],
      yAxis : [
        {
          type: 'value',
          axisLabel: {
            color: '#999',
            fontSize: 10
          },
          axisLine: { // 坐标轴线
            show: false
          },
          axisTick: { // 坐标轴刻度
            show: false
          },
          splitLine:{ // 分割线
            lineStyle:{
              color:'#999',
              type:'dashed'
            }
          }
        }
      ],
      series : [
        {
          name:'总保费',
          type:'bar',
          data:yData,
          barWidth: '25%',
          animationDuration:3000,
          barGap:'50%',
          // markPoint : {
          //   symbolSize:'40',
          //   label:{
          //     normal:{
          //       fontSize:10
          //     }
          //   },
          //   data : [
          //     {type : 'max', name: '最大值'},
          //     {type : 'min', name: '最小值'}
          //   ]
          // },
          itemStyle:{
            normal:{
              color: "rgba(63,126,253,0.7)",
            }
          }
        },
      ]
    }
  }

  render() {
    return (
      <div className="fee_charts_wrap">
        <div className="header">
          <div className="title client_title">保费收入
            {
              // ?提示
              !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) &&
              <Popover placement="bottomLeft" title='' content={this.content} trigger="hover">
                <div className="count_tips"></div>
              </Popover>
            }
          </div>
          {/*<Link to={'/'}>***</Link>*/}
        </div>
        <div className="card_body">
          {
            this.props.policyIncome.length==0?
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>:
              <ReactEcharts
                option={this.getBarOption()}
                notMerge={true}
                lazyUpdate={true}
                style={{height: '312px', width: '100%'}}
              />
          }
        </div>
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(FeeCharts)
